// @ts-nocheck
import React from "react";
import LOGO from "../assets/images/newLogo.png";
import APPNAME from "../assets/images/appname.png";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import { BASE_URL } from "../Constants/BaseUrl";

const CELL_COUNT = 6;
const RESEND_TIMEOUT = 300;

export const VerifyCode = () => {
  const [value, setValue] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [isInvalidCode, setIsInvalidCode] = React.useState(false);
  const [timer, setTimer] = React.useState(0);
  const [otpFromServer, setOtpFromServer] = React.useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { email, otp, user_id } = location.state || {};

  console.log("email: ", email);
  console.log("otp: ", otp);
  console.log("user id: ", user_id);

  React.useEffect(() => {
    if (otp) {
      setOtpFromServer(otp);
    }
  }, []);

  // Load timer from localStorage
  React.useEffect(() => {
    const init = async () => {
      const storedEmail = localStorage.getItem("resend_email");
      const storedTimestamp = localStorage.getItem("resend_timestamp");

      if (storedEmail !== email) {
        localStorage.removeItem("resend_email");
        localStorage.removeItem("resend_timestamp");
        setTimer(0);
        return;
      }

      if (storedTimestamp) {
        const now = Math.floor(Date.now() / 1000);
        const remaining =
          RESEND_TIMEOUT - (now - parseInt(storedTimestamp, 10));
        if (remaining > 0) {
          setTimer(remaining);
        } else {
          localStorage.removeItem("resend_email");
          localStorage.removeItem("resend_timestamp");
        }
      }
    };
    init();
  }, [email]);

  // Countdown timer effect
  React.useEffect(() => {
    if (timer <= 0) return;
    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          localStorage.removeItem("resend_email");
          localStorage.removeItem("resend_timestamp");
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [timer]);

  const handleSubmitCode = () => {
    if (value.length !== 6) {
      alert("Please enter the 6-digit verification code.");
      return;
    }

    setLoading(true);

    if (value.toString() !== otpFromServer?.toString()) {
      setLoading(false);
      setIsInvalidCode(true);
      toast.error("Invalid verification code. Please try again.");
      return;
    }

    setIsInvalidCode(false);
    setLoading(false);
    toast.success("Verification successful!");
    setTimeout(() => {
      navigate("/change-password", {
        state: {
          email: email,
          user_id: user_id,
          isApp: false,
        },
      });
    }, 2000);
  };

  const handleResendApi = async () => {
    setLoading(true);

    try {
      const data = new FormData();
      data.append("email", email);

      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${BASE_URL}user/forget-password`,
        data,
      };

      const response = await axios.request(config);
      console.log("Response:", response.data);

      if (response.data?.success) {
        setOtpFromServer(response.data.otp);
        toast.success("Verification email sent successfully!");
      } else {
        toast.info(
          response.data?.message || "Failed to resend verification email."
        );
      }
    } catch (error) {
      console.log("Error:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Something went wrong. Please try again.";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleResendCode = async () => {
    const now = Math.floor(Date.now() / 1000);
    setTimer(RESEND_TIMEOUT);
    localStorage.setItem("resend_email", email);
    localStorage.setItem("resend_timestamp", now.toString());
    handleResendApi();
  };

  const formatTime = (sec) => {
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${m}:${s < 10 ? "0" + s : s}`;
  };

  const handleCodeChange = (e) => {
    const newValue = e.target.value.replace(/\D/g, "").slice(0, CELL_COUNT);
    setValue(newValue);
    setIsInvalidCode(false);
  };

  return (
    <div className="min-h-screen bg-[#121212] flex items-center justify-center px-4">
      <ToastContainer />
      <div className="w-full max-w-md bg-[#1e1e1e] rounded-lg shadow-lg p-8">
        <div className="flex justify-center mb-4">
          <img src={LOGO} alt="Logo" className="h-40 w-40 object-contain" />
        </div>
        <div className="flex justify-center mb-6">
          <img src={APPNAME} alt="App Name" className="h-16 object-contain" />
        </div>

        <h2 className="text-center text-2 trailer xl Ascent-Italic text-white mb-6 uppercase">
          Reset Your Password
        </h2>
        <p className="text-center text-white mb-4">
          Enter the 6 digit code emailed to you.
        </p>

        <div className="flex justify-between mb-4">
          {[...Array(CELL_COUNT)].map((_, index) => (
            <input
              key={index}
              type="text"
              maxLength={1}
              value={value[index] || ""}
              onChange={(e) => {
                const newValue = value.split("");
                newValue[index] = e.target.value.replace(/\D/g, "");
                setValue(newValue.join(""));
                if (e.target.value && index < CELL_COUNT - 1) {
                  document.getElementsByTagName("input")[index + 1].focus();
                }
              }}
              className={`w-10 h-10 border-2 rounded-md text-center text-2xl font-sans ${
                isInvalidCode ? "border-red-500" : "border-gray-300"
              } focus:outline-none focus:ring-2 focus:ring-blue-500`}
            />
          ))}
        </div>

        <button
          onClick={handleSubmitCode}
          disabled={loading || value.length !== 6}
          className={`w-full p-3 bg-red-600 text-white rounded-md font-semibold uppercase hover:bg-red-700 transition-colors mb-4 ${
            loading || value.length !== 6 ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          {loading ? "Loading..." : "Verify Code"}
        </button>

        <button
          onClick={handleResendCode}
          disabled={timer > 0}
          className={`w-full p-3 bg-gray-500 text-white rounded-md font-semibold uppercase hover:bg-gray-600 transition-colors mb-4 ${
            timer > 0 ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          {timer > 0 ? `Resend in ${formatTime(timer)}` : "Resend Code"}
        </button>

        {/* <a
          href="/login"
          className="text-center block text-gray-600 hover:text-red-600 transition-colors"
        >
          Return to Sign In Page
        </a> */}
      </div>
    </div>
  );
};
